module.exports = __webpack_public_path__ + "img/icon_daikuan@2x.b6892f9e.png";